import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
import weekday from 'dayjs/plugin/weekday'
dayjs.extend(utc)
dayjs.extend(tz)
dayjs.extend(weekday)

/**
 * @param {Array<[string, boolean]>} attrMap
 */
const setFieldStatePrototype = (attrMap) =>
  /**
   * @param {HTMLElement} control
   * @param {boolean} enable
   */
  (control, enable) => {
    attrMap.forEach(([attr, invert]) => {
      let field = control.closest('.form-field') || console.warn('Undefined field for control')
      if (enable ^ invert) {
        control.setAttribute(attr, attr)
        field && field.classList.add(`-is-${attr}`)
      } else {
        control.removeAttribute(attr)
        field && field.classList.remove(`-is-${attr}`)
      }
    })
  }

const setFieldState = setFieldStatePrototype([
  ['disabled', true],
  ['hidden', true],
  ['readonly', true],
  ['required', false],
])

const setFieldStateNotHide = setFieldStatePrototype([
  ['disabled', true],
  ['readonly', true],
  ['required', false],
])

/**
 * @param {HTMLElement} formElement
 */
let setOrderType = (formElement) =>
  /**
   * @param {Event} event
   */
  (event) => {
    formElement.state.type = event.target.value
    updateForm(formElement)(formElement.state.type, formElement.state.calculation)
  }

/**
 * @param {HTMLElement} formElement
 */
let setOrderCalculation = (formElement) =>
  /**
   * @param {Event} event
   */
  (event) => {
    formElement.state.calculation = event.target.checked
    updateForm(formElement)(formElement.state.type, formElement.state.calculation)
  }

/**
 * @param {HTMLSelectElement} fileFormatControl
 * @param {string} optionClass
 * @param {boolean} enable
 */
let setFileFormatOptionsState = (fileFormatControl, optionClass, enable) => {

  Array.from(fileFormatControl.options).forEach((optionElement) => {
    optionElement.remove()
  })

  fileFormatControlOptions.forEach((optionElement) => {
    if ( optionElement.classList.contains(optionClass) || optionElement.value == 'comment' || optionElement.value == '-' ) {
      //console.log(optionElement)
      fileFormatControl.options.add(optionElement)
    }
  })

  /*Array.from(fileFormatControl.options).forEach((optionElement) => {
    if (optionElement.classList.contains(optionClass)) {
      ['disabled', 'hidden'].forEach((attr) => {
        if (enable) {
          optionElement.removeAttribute(attr)
        } else {
          optionElement.setAttribute(attr, attr)
        }
      })
    }
  })*/
}

/**
 * @param {HTMLSelectElement} fileFormatControl
 */
let updateFileFormatValue = (fileFormatControl, optionClass) => {
  if (!Array.from(fileFormatControl.options).find(
    (optionElement) => {
      return optionElement.selected && !optionElement.disabled && !(optionElement.value === 'comment') && !(optionElement.value === '-')
    }
  )) {
    fileFormatControl.value = Array.from(fileFormatControl.options).find(
      (optionElement) => {
        return !optionElement.disabled
      }
    ).value


    if( optionClass === '--embroidery' && fileFormatEmbroideryDefault && fileFormatControl.value == '-' ) {
      fileFormatControl.value = fileFormatEmbroideryDefault
    }
    else if( optionClass === '--vector' && fileFormatVectorDefault && fileFormatControl.value == '-' ) {
      fileFormatControl.value = fileFormatVectorDefault
    }

  }
  // Fix required validation
  // noinspection SillyAssignmentJS
  fileFormatControl.required = fileFormatControl.required
}

/**
 * @param {HTMLElement} formElement
 */
let updateForm = (formElement) =>
  /**
   * @param {string} type
   * @param {boolean} calculation
   */
  (type, calculation) => {
    let widthControl = document.getElementById('order_new_form_width')
    let heightControl = document.getElementById('order_new_form_height')
    let sizeAttacheControl = document.getElementById('order_new_form_size_as_in_attachment')
    let sizeSeparator = document.getElementById('form-separator__by-size')

    let materialControl = document.getElementById('order_new_form_material')
    let colorAmountControl = document.getElementById('order_new_form_color_amount')
    let fileFormatControl = document.getElementById('order_new_form_file_format')
    if (!(fileFormatControl instanceof HTMLSelectElement)) {
      fileFormatControl = null
    }

    let alwaysUseThisFormatControl = document.getElementById('order_new_form_always_use_this_format')
    let alwaysUseThisFormatBlock = document.getElementById('always_use_this_format')

    if (!(materialControl && colorAmountControl && fileFormatControl)) {
      console.warn('Invalid order new form controls')
      return
    }

    let priorityControl = document.getElementById('order_new_form_priority')

    if (type === 'embroidery' && calculation === true) {
      setFieldState(priorityControl, false)
      setFieldState(materialControl, false)
      setFieldState(colorAmountControl, true)
      setFieldState(fileFormatControl, false)
      setFileFormatOptionsState(fileFormatControl, '--embroidery', true)
      //setFileFormatOptionsState(fileFormatControl, '--vector', false)
      updateFileFormatValue(fileFormatControl, '--embroidery')

      setFieldState(alwaysUseThisFormatControl, false)
      alwaysUseThisFormatBlock.style.display = 'none'

      setFieldState(widthControl, true)
      setFieldState(heightControl, true)
      setFieldState(sizeAttacheControl, true)
      sizeSeparator.style.display = 'block'

    } else if (type === 'vector' && calculation === true) {
      setFieldState(priorityControl, false)
      setFieldState(materialControl, false)
      setFieldState(colorAmountControl, false)
      setFieldState(fileFormatControl, false)
      //setFileFormatOptionsState(fileFormatControl, '--embroidery', false)
      setFileFormatOptionsState(fileFormatControl, '--vector', true)
      updateFileFormatValue(fileFormatControl, '--vector')

      setFieldState(alwaysUseThisFormatControl, false)
      alwaysUseThisFormatBlock.style.display = 'none'

      setFieldState(widthControl, false)
      setFieldState(heightControl, false)
      setFieldState(sizeAttacheControl, false)
      sizeSeparator.style.display = 'none'

    } else if (type === 'embroidery' && calculation === false) {
      setFieldState(priorityControl, true)
      setFieldState(materialControl, true)
      setFieldState(colorAmountControl, true)
      setFileFormatOptionsState(fileFormatControl, '--embroidery', true)
      //setFileFormatOptionsState(fileFormatControl, '--vector', false)
      updateFileFormatValue(fileFormatControl, '--embroidery')
      setFieldState(fileFormatControl, true)

      setFieldState(alwaysUseThisFormatControl, true)
      alwaysUseThisFormatBlock.style.display = 'block'

      setFieldState(widthControl, true)
      setFieldState(heightControl, true)
      setFieldState(sizeAttacheControl, true)
      sizeSeparator.style.display = 'block'

    } else if (type === 'vector' && calculation === false) {
      setFieldState(priorityControl, true)
      setFieldState(materialControl, false)
      setFieldState(colorAmountControl, false)
      //setFileFormatOptionsState(fileFormatControl, '--embroidery', false)
      setFileFormatOptionsState(fileFormatControl, '--vector', true)
      updateFileFormatValue(fileFormatControl, '--vector')
      setFieldState(fileFormatControl, true)

      setFieldState(alwaysUseThisFormatControl, true)
      alwaysUseThisFormatBlock.style.display = 'block'

      setFieldState(widthControl, false)
      setFieldState(heightControl, false)
      setFieldState(sizeAttacheControl, false)
      sizeSeparator.style.display = 'none'

    } else {
      setFieldState(materialControl, false)
      setFieldState(colorAmountControl, false)
      setFieldState(fileFormatControl, false)
      //setFileFormatOptionsState(fileFormatControl, '--embroidery', false)
      setFileFormatOptionsState(fileFormatControl, '--vector', false)
      updateFileFormatValue(fileFormatControl, '--vector')

      setFieldState(alwaysUseThisFormatControl, false)
      alwaysUseThisFormatBlock.style.display = 'none'

      setFieldState(widthControl, false)
      setFieldState(heightControl, false)
      setFieldState(sizeAttacheControl, false)
      sizeSeparator.style.display = 'none'

      console.warn('Invalid order new form state (type: '+type+', calculation: '+calculation+')')
    }

    let message30Min = document.getElementById('order_new_form_30_min')
    let messageNeeded = document.getElementById('order_new_form_needed')
    if( calculation === true ) {
      message30Min.style.display = 'block'
      messageNeeded.style.display = 'none'
    }
    else {
      message30Min.style.display = 'none'
      messageNeeded.style.display = 'block'
    }
  }

/**
 * @param {HTMLInputElement} widthElement
 * @param {HTMLInputElement} heightElement
 * @param {boolean} enable
 */
let setSizeFieldState = (widthElement, heightElement, enable) => {
  setFieldStateNotHide(widthElement, enable)
  setFieldStateNotHide(heightElement, enable)
  if (!enable) {
    widthElement.value = heightElement.value = ''
  }
}


let onChangePriority = (event) => {
  let hours = 72
  let priority = ''

  if( event ) {
    priority = event.target.value
  }
  else {
    const priorityElement = document.getElementById('order_new_form_priority')
    priority = priorityElement.value
  }

  if( priority === 'low' ) {
    hours = 72
  }
  else if( priority === 'regular' ) {
    hours = 48
  }
  else if( priority === 'urgent' ) {
    hours = 24
  }
  else if( priority === 'express' ) {
    hours = 6
  }

  let dateNeeded = dayjs().add(hours, 'hours').tz("Europe/Vienna")
  //let dateNeededBefore = dayjs().add(hours, 'hours').tz("Europe/Vienna")

  //console.log('dateNeeded before: ' + dateNeededBefore.format('YYYY-MM-DD HH:mm'))

  let weekDay = dayjs().tz("Europe/Vienna").day();

  if( priority === 'express' ) {
    let dateFriday = '';
    if( weekDay == 5 ) {
      dateFriday = dayjs().tz("Europe/Vienna").hour(17).minute(0)
    }
    else {
      dateFriday = dayjs().tz("Europe/Vienna").weekday(6).hour(17).minute(0);
    }

    //console.log('dateFriday: ' + dateFriday.format('YYYY-MM-DD HH:mm'))

    if( dateNeeded.isAfter(dateFriday) ) {
      //console.log('+++')
      let dateMonday = dateFriday.tz("Europe/Vienna").add(64, 'hours');

      //console.log('dateMonday: ' + dateMonday.format('YYYY-MM-DD HH:mm'))

      dateNeeded = dateMonday.add(6, 'hours')
    }

    //console.log('dateNeeded after: ' + dateNeeded.format('YYYY-MM-DD HH:mm'))
  }
  else {
    let dateSaturday = '';
    if( weekDay == 6 ) {
      dateSaturday = dayjs().tz("Europe/Vienna").hour(14).minute(0)
    }
    else {
      dateSaturday = dayjs().tz("Europe/Vienna").weekday(6).hour(14).minute(0);
    }

    //console.log('dateSaturday: ' + dateSaturday.format('YYYY-MM-DD HH:mm'))

    if( dateNeeded.isAfter(dateSaturday) ) {
      //console.log('+++')
      dateNeeded = dateNeeded.add(48, 'hours')
    }

    //console.log('dateNeeded after: ' + dateNeeded.format('YYYY-MM-DD HH:mm'))
  }

  //console.log(dayjs().tz("Europe/Vienna").day())



  //console.log(dateNeeded.format('YYYY-MM-DD HH:mm'))

  const neededDate = document.getElementById('order_new_form_needed_date')
  const neededTime = document.getElementById('order_new_form_needed_time')
  neededDate.innerText = dateNeeded.format('YYYY-MM-DD')
  neededTime.innerText = dateNeeded.format('HH:mm')
}





let fileFormatControlOptions = []
let fileFormatEmbroideryDefault = '';
let fileFormatVectorDefault = '';

/**
 * @param {HTMLElement} formElement
 */
export default (formElement) => {

  let fileFormatEmbroideryDefaultControl = document.getElementById('fileFormatEmbroideryDefault')
  if( fileFormatEmbroideryDefaultControl ) {
    fileFormatEmbroideryDefault = fileFormatEmbroideryDefaultControl.value
  }

  let fileFormatVectorDefaultControl = document.getElementById('fileFormatVectorDefault')
  if( fileFormatVectorDefaultControl ) {
    fileFormatVectorDefault = fileFormatVectorDefaultControl.value
  }

  let fileFormatControl = document.getElementById('order_new_form_file_format')
  if (!(fileFormatControl instanceof HTMLSelectElement)) {
    fileFormatControl = null
  }

  if( fileFormatControl ) {
    //let currentFileFormat = ''
    Array.from(fileFormatControl.options).forEach((optionElement) => {
      //console.log(optionElement)
      let newOption = new Option(optionElement.text, optionElement.value)
      optionElement.classList.forEach((value)=>{
        newOption.classList.add(value)
      })
      //newOption.selected = optionElement.selected

      /*if( optionElement.selected ){
        currentFileFormat = optionElement.value
      }*/

      fileFormatControlOptions.push( newOption )
    })

    //console.log(currentFileFormat)
  }

  formElement.state = {type: null, calculation: null}
  let typeElement = document.getElementById('order_new_form_type')
  typeElement && typeElement.querySelectorAll('input[type=radio]').forEach((e) => {
    e.addEventListener('change', setOrderType(formElement))
    if (e.checked) {
      formElement.state.type = e.value
    }
  })
  let calculationElement = document.getElementById('order_new_form_calculate')
  formElement.state.calculation = calculationElement && calculationElement.checked
  calculationElement && calculationElement.addEventListener('change', setOrderCalculation(formElement))
  updateForm(formElement)(formElement.state.type, formElement.state.calculation)
  let widthElement = document.getElementById('order_new_form_width')
  let heightElement = document.getElementById('order_new_form_height')
  let sizeAsInAttachmentElement = document.getElementById('order_new_form_size_as_in_attachment')
  sizeAsInAttachmentElement && sizeAsInAttachmentElement.addEventListener('change', (e) => {
    setSizeFieldState(widthElement, heightElement, !e.target.checked)
  })
  setSizeFieldState(widthElement, heightElement, !sizeAsInAttachmentElement.checked)


  let priorityElement = document.getElementById('order_new_form_priority')

  priorityElement && priorityElement.addEventListener('change', onChangePriority)
  onChangePriority()


  var resizeTextarea = function(el) {
    //console.log('resizeTextarea')
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
    //console.log(el.scrollHeight)
    //$(el).css('height', 'auto').css('height', el[0].scrollHeight + offset);
  }

  const commentControl = document.getElementById('order_new_form_comment')
  if( commentControl ) {
    resizeTextarea(commentControl)
    commentControl.addEventListener('keyup', function() { resizeTextarea(commentControl) })
    commentControl.addEventListener('input', function() { resizeTextarea(commentControl) })
  }


  //updateForm(formElement)(formElement.state.type, formElement.state.calculation)


  /*formElement.addEventListener('submit', (event)=>{
    if( formElement.state.calculation === false ) {
      if( fileFormatControl ) {
        if( fileFormatControl.value == '-' ) {
          //event.preventDefault();
        }
      }
    }
  });*/


  /*autoresize(textarea) {
    var offset = 0;
    var resizeTextarea = function(el) {
      $(el).css('height', 'auto').css('height', el[0].scrollHeight + offset);
    };
    resizeTextarea(textarea);
    textarea.on('keyup input', function() { resizeTextarea(textarea); }).addClass('resized');
  },*/
}
